<script>
  import {s3linkfrom} from "../EndpointsAndTransforms";
  export let name;
  $: link = s3linkfrom(name)
</script>

<main>
  <img src={link} />
</main>

<style>
  main {
    line-height: 0;
    margin: 0px;
    padding-left: 1rem; padding-right: 1rem;
  }

  img {
    width: 100% !important;
    height: auto !important;
    object-fit: cover;
    max-height: 300px;
    margin: 0px;
    padding: 0px;
  }
</style>


